import { CapoPlugin } from "/builds/1tool/kfv-puk-app/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];